import { DialogContent, IconButton } from "@material-ui/core";
import ListIcon from '@material-ui/icons/List';
import { Dialog } from "@mui/material";
import { useState } from "react";
import SlaTable from "./SlaTable";


const SlaListDialog = ({ washSlaData }) => {

    const [showList, setShowList] = useState(false);
    return (
        <>
            <IconButton size="small" onClick={() => setShowList(true)}><ListIcon /></IconButton>
            <Dialog maxWidth='xl'
                fullWidth open={showList} onClose={() => setShowList(false)}>
                <DialogContent>
                    <SlaTable
                        washSlaData={washSlaData}
                    />
                </DialogContent>
            </Dialog>
        </>
    )
}

export default SlaListDialog;